import { render, staticRenderFns } from "./Acceso.vue?vue&type=template&id=1ab97159&"
import script from "./Acceso.vue?vue&type=script&lang=js&"
export * from "./Acceso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports